import { render, staticRenderFns } from "./ConfirmMobileNumber.vue?vue&type=template&id=613c964e&scoped=true"
import script from "./ConfirmMobileNumber.vue?vue&type=script&lang=js"
export * from "./ConfirmMobileNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c964e",
  null
  
)

export default component.exports